module.exports = __webpack_public_path__ + "static/media/uploadDocBtn.7cedf376.png";